export enum SwapStage {
  TransferSwap,
  Deposit,
  Swap,
  Withdraw,
  TransferNFID,
  Completed,
}

export enum SwapName {
  ICPSwap = "ICPSwap",
  Kongswap = "Kongswap",
}

export enum PriceImpactStatus {
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
}
